<template>
  <nav ref="navbar" class="navbar bg-primary navbar-expand-lg" data-bs-theme="dark">
    <div class="container-fluid">
      <router-link class="navbar-brand" to="/" @click="closeNavbar">Accueil</router-link>
      <button 
        class="navbar-toggler" 
        type="button" 
        @click="toggleNavbar"
        aria-controls="navbarSupportedContent"
        :aria-expanded="isNavbarOpen"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div 
        class="collapse navbar-collapse" 
        :class="{ 'show': isNavbarOpen }" 
        id="navbarSupportedContent" 
        ref="navbarCollapse"
      >
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item">
            <router-link class="nav-link active" to="/mosaic" @click="closeNavbar">Pixel Arts</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link active" to="/place" @click="closeNavbar">Place Publique</router-link>
          </li>
          <router-link to="/pwa" class="nav-link">
            Installer l'app
          </router-link>
        </ul>
        <div class="d-flex">
          <div class="btn-group" data-bs-theme="light">
            <button type="button" class="btn profile-btn" data-bs-toggle="dropdown" aria-expanded="false">
              <!-- Photo de profil si elle existe -->
              <img 
                v-if="profilePicture" 
                :src="profilePicture" 
                alt="Photo de profil" 
                class="profile-picture-navbar"
              />
              <!-- Icône par défaut sinon -->
              <img 
                v-else
                src="/images/image_dure/utilisateur.svg" 
                alt="Icone utilisateur" 
                class="img-fluid p-1" 
                style="max-width: 70px;"
              />
            </button>
            <ul class="dropdown-menu dropdown-menu-lg-end">
              <li v-if="isAuthenticated">
                <router-link class="dropdown-item" to="/ProfileManager" @click="closeNavbar">Profile</router-link>
              </li>
              <li v-if="isAuthenticated">
                <router-link class="dropdown-item" to="/logout" @click="closeNavbar">Déconnexion</router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <span v-if="debugAuth" style="display:none;"></span>
  </nav>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import axios from 'axios';

export default {
  name: 'MainNavbar',
  data() {
    return {
      profilePicture: null,
      isNavbarOpen: false
    };
  },
  mounted() {
    this.updateNavbarHeight();
    window.addEventListener('resize', this.updateNavbarHeight);
    
    // Fermer la navbar si on clique en dehors
    document.addEventListener('click', this.handleClickOutside);
    
    // Charger la photo de profil si l'utilisateur est connecté
    if (this.isAuthenticated) {
      this.fetchProfilePicture();
    }
    window.addEventListener('profile-picture-updated', this.fetchProfilePicture);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateNavbarHeight);
    window.removeEventListener('profile-picture-updated', this.fetchProfilePicture);
    document.removeEventListener('click', this.handleClickOutside);
  },
  computed: {
    ...mapGetters('auth', ['isAuthenticated', 'userId', 'userEmail']),
    debugAuth() {
      console.log('[Navbar Debug] Auth State:', {
        isAuthenticated: this.isAuthenticated,
        userId: this.userId,
        userEmail: this.userEmail
      });
      return true;
    }
  },
  created() {
    this.checkAuthentication();
  },
  watch: {
    '$store.state.auth.isAuthenticated'(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.checkAuthentication();
        
        if (newVal) {
          this.fetchProfilePicture();
        } else {
          this.profilePicture = null;
        }
      }
    },
    '$route'() {
      // Fermer la navbar lors du changement de route
      this.closeNavbar();
    }
  },
  methods: {
    ...mapActions('auth', ['checkAuthentication', 'login', 'logout']),
    
    toggleNavbar() {
      this.isNavbarOpen = !this.isNavbarOpen;
      console.log('Navbar toggled:', this.isNavbarOpen);
    },

    closeNavbar() {
      if (this.isNavbarOpen) {
        this.isNavbarOpen = false;
        console.log('Navbar closed');
      }
    },

    handleClickOutside(event) {
      const navbar = this.$refs.navbar;
      if (!navbar) return;

      // Si le menu est ouvert et qu'on clique en dehors de la navbar
      if (this.isNavbarOpen && !navbar.contains(event.target)) {
        this.closeNavbar();
      }
    },
    
    async fetchProfilePicture() {
      try {
        const token = localStorage.getItem('token');
        if (!token) return;
        const API_URL = process.env.VUE_APP_API_URL || 'https://brickfirst.fr';
        const response = await axios.get(`${API_URL}/api/profile`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (response.data.profilePicture) {
          this.profilePicture = response.data.profilePicture;
        }
        this.updateNavbarHeight();
      } catch (error) {
        console.error('Erreur lors du chargement de la photo de profil:', error);
      }
    },

    updateNavbarHeight() {
      this.$nextTick(() => {
        const navbarHeight = this.$refs.navbar.offsetHeight;
        document.documentElement.style.setProperty('--hauteurNavbar', `${navbarHeight}px`);
        console.log('[DEBUG] Hauteur de la Navbar mise à jour:', navbarHeight);
      });
    }
  }
};
</script>

<style scoped>
nav ul {
  list-style-type: none;
  padding: 0;
}

nav ul li {
  display: inline;
  margin-right: 10px;
}

li[data-v-66dd064e] {
  margin: 0;
  padding: 0;
}

/* Style pour la photo de profil dans la navbar */
.profile-picture-navbar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #ffffff;
  padding: 2px;
  background-color: #ffffff;
}

.profile-btn {
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.profile-btn:hover .profile-picture-navbar {
  border-color: #4dc9ff;
}

/* Amélioration du toggler sur mobile */
.navbar-toggler {
  border: 2px solid rgba(255, 255, 255, 0.5);
  padding: 0.5rem 0.75rem;
}

.navbar-toggler:focus {
  box-shadow: 0 0 0 0.25rem rgba(255, 255, 255, 0.25);
  outline: none;
}

.navbar-toggler:active {
  background-color: rgba(255, 255, 255, 0.1);
}

.navbar-toggler-icon {
  width: 1.5em;
  height: 1.5em;
}

/* Transition fluide pour le collapse */
.navbar-collapse {
  transition: max-height 0.3s ease-in-out, opacity 0.3s ease-in-out;
  max-height: 0;
  opacity: 0;
  overflow: visible;
}

.navbar-collapse.show {
  max-height: 500px;
  opacity: 1;
  overflow: visible;
}

/* Sur mobile, améliorer l'espacement */
@media (max-width: 991.98px) {
  .navbar-nav {
    padding: 1rem 0;
  }
  
  .nav-item {
    padding: 0.5rem 0;
  }
  
  .navbar-collapse.show {
    background-color: rgba(13, 110, 253, 0.98);
    padding: 1rem;
    border-radius: 0.5rem;
    margin-top: 0.5rem;
  }

  .nav-link {
    padding: 0.75rem 1rem;
  }

  .nav-link:hover {
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 0.25rem;
  }
}

/* Sur desktop, réinitialiser les transitions */
@media (min-width: 992px) {
  .navbar-collapse {
    max-height: none !important;
    opacity: 1 !important;
    overflow: visible !important;
  }
}
</style>